import React, { useMemo, useEffect, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_THING_ID, DEFAULT_THING_VERSION } from '@kemu-io/kemu-core/common/constants';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import { selectCurrentRecipePoolId, selectOpeningRecipe } from '../Workspace/workspaceSlice';
import LogicMapperSection from '@components/layout/HorizontalSplit/LogicMapperSection';
import { SelectedBlockInfo } from '@src/types/core_t';
import MainMenu from '@components/mainMenu/mainMenu';
import routes from '@common/routes';
import classNames from 'classnames';
import { SITE_LAYOUT_ELEMENT_CLASS } from '@common/constants';
import { ShowHelpConfig } from '@common/context/LogicMapperContext/LogicMapperContext';
import { selectColorScheme } from '../interface/interfaceSlice';


const DesktopRecipeScreen = (): React.JSX.Element | null => {
  const recipePoolId = useSelector(selectCurrentRecipePoolId);
  const openingRecipe = useSelector(selectOpeningRecipe);
  const colorScheme = useSelector(selectColorScheme);
  const navigate = useNavigate();
  const [showHelpConfig, setShowHelpConfig] = useState<ShowHelpConfig | null>(null);

  const defaultThing: SelectedBlockInfo = useMemo(() => {
    return {
      DbId: DEFAULT_THING_ID,
      recipeId: DEFAULT_THING_ID,
      recipePoolId: recipePoolId || '',
      title: '',
      version: DEFAULT_THING_VERSION,
    };
  }, [recipePoolId]);

  const handleShowHelp = useCallback((config: ShowHelpConfig | null) => {
    setShowHelpConfig(config);
  }, []);


  useEffect(() => {
    if (!recipePoolId) {
      navigate(routes.getBaseRoute());
    }
  }, [recipePoolId, navigate]);

  if (!recipePoolId) { return null; }

  return (
    <DndProvider backend={HTML5Backend}>
      <div id="layout-container" data-theme={colorScheme}>
        <Layout className={classNames('layout-section', SITE_LAYOUT_ELEMENT_CLASS)} style={{ flexDirection: 'row' }}>
          <MainMenu collapsed={true} onShowHelp={handleShowHelp} />
          {!openingRecipe && (
            <LogicMapperSection
              openedBlock={defaultThing}
              recipePoolId={recipePoolId}
              visible={true}
              showMenuHelpConfig={showHelpConfig}
            />
          )}
        </Layout>
      </div>
    </DndProvider>
  );
};

export default DesktopRecipeScreen;
